import { useEffect, useState } from 'react';
import { months } from '../utils';

const useGraphData = ({
  apiHandler,
  type,
  filterValue,
  isDependency,
  isGraph,
}) => {
  const { startDate, endDate, location, fromDate, toDate } = filterValue;
  const [graphData, setGraphData] = useState({});
  const [graphLoader, setGraphLoader] = useState(false);

  const getLables = () => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const result = [];
    const currentDate = new Date();
    for (let i = 11; i >= 0; i--) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      const monthName = months[date.getMonth()];
      const year = date.getFullYear();
      result.push(`${monthName} ${year}`);
    }
    return result;
  };

  useEffect(() => {
    if (apiHandler && isGraph) {
      getGraphDetails(apiHandler);
    }
  }, [apiHandler, isDependency, isGraph]);

  const getData = (arr) => {
    try {
      let result = [];
      const currentDate = new Date();
      for (let i = 11; i >= 0; i--) {
        let date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
        let year = date.getFullYear();
        let monthIndex = date.getMonth() + 1;
        let data = arr.filter(item => {
          return item.month === monthIndex && item.year === year
        })
        if (data.length > 0) {
          result.push(data[0]?.monthlyCollectedAmount);
        } else {
          result.push(0);
        }
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  };
  // const getData = (arr) => {
  //   try {
  //     const collections = new Array(12).fill(0);
  //     arr?.forEach((v) => {
  //       collections.splice(
  //         v?.month - 1,
  //         0,
  //         parseFloat(v?.monthlyCollectedAmount).toFixed(2)
  //       );
  //     });
  //     return collections;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getGraphDetails = async (GraphAPI) => {
    try {
      setGraphLoader(true);
      const queryParams = {
        type: type,
        startDate: startDate || fromDate,
        endDate: endDate || toDate,
        location: location,
        currentDate: new Date(),
      };
      const res = await GraphAPI({ queryParams });
      if (res.success) {
        setGraphData({
          ...graphData,
          remainingMonthlyCollectedAmount: getData(
            res?.data?.remainingCollection
          ),
          MonthlyCollectedAmount: getData(res?.data?.collection),
          totalData: res?.data?.allCollection,
          labels: getLables()
        });
      }
    } catch (error) {
      console.log(error);
    }
    setGraphLoader(false);
  };
  return [graphData, graphLoader];
};
export default useGraphData;
